import React from 'react';
import { Layout } from 'antd';
import styles from './Header.module.scss'
import logo from '../../../assets/images/logo.png'
import { useAuthStore } from '../../../stores/authStore';
import { useNavigate } from 'react-router-dom';
import {LogoutOutlined, MenuOutlined} from '@ant-design/icons';
import {getIsDev, getIsLocal} from "../../../util/host";

const { Header: AntHeader } = Layout;

interface HeaderProps {
  onClick?: () => any;
}

const Header: React.FC<HeaderProps> = ({ onClick }: HeaderProps) => {
  const isLocal = getIsLocal();
  const isDev = getIsDev();
  const navigate = useNavigate();
  const isLoggedIn = useAuthStore((state) => state.isLoggedIn);
  const logout = useAuthStore((state) => state.logout);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <AntHeader className={styles.header}>
      <MenuOutlined onClick={onClick} className={styles.hamburger} />
      <div className={styles.appTitleWrap}>
        <img src={logo} alt="logo" />
        <span>배차장 운영</span>
        {isLocal && <span>(로컬)</span>}
        {isDev && <span>(개발)</span>}
      </div>
      <div className={styles.profileIconWrap}>
        <div className={styles.profileIcon}>
          { isLoggedIn ? (<span onClick={handleLogout}><LogoutOutlined style={{fontSize: '18px', color: '#8dadd6'}}/></span>)
            : (<span></span>)
          }
        </div>
      </div>
    </AntHeader>
);
};

export default Header;
